module.exports = __webpack_public_path__ + "static/media/exclamation-circle.7b9c00b7.svg";